import Fade from '@material-ui/core/Fade'
import { ChatDrawerMessage } from 'ducks/chatDrawer'
import { CheckOutlineIcon, CopyLeftOutlineIcon, IconButton, Tooltip } from 'opensolar-ui'
import React, { useEffect, useState } from 'react'
import { useTranslate } from 'react-admin'

interface CopyMessageButtonProps {
  message: ChatDrawerMessage
}

export const CopyMessageButton: React.FC<CopyMessageButtonProps> = ({ message }) => {
  const translate = useTranslate()
  const [isCopied, setIsCopied] = useState(false)
  const [tooltipOpen, setTooltipOpen] = useState(false)

  const handleCopyMessage = async () => {
    if (!message.content) {
      return
    }

    try {
      await navigator.clipboard.writeText(message.content)
      setIsCopied(true)
      setTooltipOpen(true)
      setTimeout(() => {
        setTooltipOpen(false)
        setTimeout(() => {
          setIsCopied(false)
        }, 200)
      }, 2000)
    } catch (error) {
      console.error('Failed to copy message:', error)
    }
  }

  // Close tooltip when user hovers away (if not in copied state)
  useEffect(() => {
    if (!isCopied && tooltipOpen) {
      const timer = setTimeout(() => {
        setTooltipOpen(false)
      }, 100)
      return () => clearTimeout(timer)
    }
  }, [isCopied, tooltipOpen])

  const tooltipTitle = isCopied ? translate('Message copied to clipboard') : translate('Copy message')

  return (
    <Tooltip
      title={tooltipTitle}
      placement="top"
      open={tooltipOpen}
      onClose={() => setTooltipOpen(false)}
      onOpen={() => !isCopied && setTooltipOpen(true)}
      disableHoverListener={isCopied}
      disableFocusListener={isCopied}
      disableTouchListener={isCopied}
    >
      <IconButton size="small" onClick={handleCopyMessage} style={{ padding: '4px', flexShrink: 0 }}>
        <div
          style={{
            position: 'relative',
            width: '16px',
            height: '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Fade in={!isCopied} timeout={200} unmountOnExit>
            <div style={{ position: 'absolute', top: '55%', left: '50%', transform: 'translate(-50%, -50%)' }}>
              <CopyLeftOutlineIcon size={16} />
            </div>
          </Fade>
          <Fade in={isCopied} timeout={200} unmountOnExit>
            <div style={{ position: 'absolute', top: '55%', left: '50%', transform: 'translate(-50%, -50%)' }}>
              <CheckOutlineIcon size={16} />
            </div>
          </Fade>
        </div>
      </IconButton>
    </Tooltip>
  )
}
